// import THREE from "threejs";

const NotImplementedException = function () { throw new Error("Mut be implemented in inheriting class."); }

class BaseInteractableGeometry {
    constructor() {
        this.objects = [];
        this.objectsHtml = [];
        this.colliders = null;

        this.colorMesh = 0xffffff;
        this.colorInteractable = 0x000000;
        this.colorHighlight = 0x00ffff;


        this._init();
    }

    _init() {
        const mesh = this._createMesh();

        this.objects.push(mesh);

        const { objects: colliderObjects, colliders, htmls } = this._createColliders();

        this.colliders = colliders;
        // this.objects.push(...colliders);
        this.objects.push(...colliderObjects);
        Object.keys(colliders).forEach(key => this.objects.push(colliders[key]));

        // this.colliders.push(...colliders);
        this.objectsHtml.push(...htmls);


    }

    _createMesh() { throw NotImplementedException(); }
    _createColliders() { throw NotImplementedException(); }

    _createRingCollider({
        axis = new THREE.Vector3(),
        angle = 0,
        translation = new THREE.Vector3(),
        color = this.colorInteractable,
        colorHighlight = this.colorHighlight,
        interactableType }) {
        const matrix = new THREE.Matrix4()
            .makeRotationFromQuaternion(new THREE.Quaternion().setFromAxisAngle(axis, angle))
            .setPosition(translation);

        const mesh = createRingMesh({ matrix, color });
        const collider = createRingCollider({ matrix, color });

        collider.highlight = () => { mesh.material.color.setHex(colorHighlight); };
        collider.deselect = () => { mesh.material.color.setHex(color); };

        collider.interactableType = interactableType;

        return { mesh: mesh, collider };

    }

    _createAxisCollider({
        axis = new THREE.Vector3(),
        angle = 0,
        translation = new THREE.Vector3(),
        halfWidth = false,
        color = this.colorInteractable,
        colorHighlight = this.colorHighlight,
        interactableType }) {
        const matrix = new THREE.Matrix4()
            .makeRotationFromQuaternion(new THREE.Quaternion().setFromAxisAngle(axis, angle))
            .setPosition(translation);

        const mesh = createLine({ color: color, matrix, halfWidth });
        const collider = createLinePointCollider({ color: color, matrix, halfWidth });

        collider.highlight = () => { mesh.material.color.setHex(colorHighlight); };
        collider.deselect = () => { mesh.material.color.setHex(color); };

        collider.interactableType = interactableType;

        return { mesh, collider };
    }

    get formulas() { return []; }
}

export default BaseInteractableGeometry;
export { BaseInteractableGeometry };

function createLine({ matrix, color = 0xff00ff, halfWidth = false } = {}) {
    const geometry = new THREE.BufferGeometry();
    const positionAttribute = new THREE.Float32BufferAttribute(halfWidth ? [0, 0, 0, 1, 0, 0] : [-0.5, 0, 0, 0.5, 0, 0], 3);

    geometry.addAttribute("position", positionAttribute);

    geometry.applyMatrix(matrix);

    const material = new THREE.LineBasicMaterial({ color, linewidth: 2, depthWrite: false, depthTest: false, transparent: true });

    return new THREE.LineSegments(geometry, material);
}

function createLinePointCollider({ color = 0xff00ff, matrix, halfWidth = false }) {
    const geometry = new THREE.BoxBufferGeometry(0.5, 0.5, 0.5);
    const material = new THREE.MeshBasicMaterial({ depthWrite: false, color, depthTest: false });

    geometry.translate(halfWidth ? 1 : 0.5, 0, 0);
    geometry.applyMatrix(matrix);

    const mesh = new THREE.Mesh(geometry, material);

    mesh.visible = false;

    return mesh;
}

function createRingMesh({ matrix, color = 0xff00ff }) {
    const sourceGeometry = new THREE.CircleBufferGeometry(1, 64);

    sourceGeometry.rotateX(Math.PI * 0.5);
    sourceGeometry.applyMatrix(matrix);

    const geometry = new THREE.EdgesGeometry(sourceGeometry);
    const material = new THREE.LineBasicMaterial({ color, linewidth: 2, depthTest: false, depthWrite: false, transparent: true });

    return new THREE.LineSegments(geometry, material);
}

function createRingCollider({ matrix, color = 0xff00ff }) {
    const geometry = new THREE.TorusBufferGeometry(1, 0.5, 16, 16);

    geometry.rotateX(Math.PI * 0.5);
    geometry.applyMatrix(matrix);

    const material = new THREE.MeshBasicMaterial({ color, depthWrite: false, depthTest: false });

    const mesh = new THREE.Mesh(geometry, material);

    mesh.visible = false;

    return mesh;
}